// @ts-check

/**
 * @typedef {Object} WindowWithFlags
 * @property {string} [FF_DEV_VIEW]
 * @property {string} [FF_WALLET_VERIFICATION]
 * @property {string} [FF_KYC_VERIFICATION]
 * @property {string} [FF_REDEEM_CONTAINER]
 * @property {string} [FF_ASSERTIONS]
 * @property {string} [BUILD_MODE]
 * @property {string} [FF_LOGIN]
 */

/** @type {Window & WindowWithFlags} */
const win = window

/**
 * @param {string} envVar
 * @param {boolean} fallback
 * @returns {boolean}
 */
export function flag(envVar, fallback) {
  if (envVar) {
    return envVar === 'true'
  } else {
    return fallback
  }
}

/**
 * @type {Object<string, boolean>}
 */
export const featureFlags = {
  development: {
    FF_DEV_VIEW: flag(win.FF_DEV_VIEW, false),
    FF_WALLET_VERIFICATION: flag(win.FF_WALLET_VERIFICATION, true),
    FF_KYC_VERIFICATION: flag(win.FF_KYC_VERIFICATION, true),
    FF_REDEEM_CONTAINER: flag(win.FF_REDEEM_CONTAINER, true),
    FF_ASSERTIONS: flag(win.FF_ASSERTIONS, true),
    FF_LOGIN: flag(win.FF_LOGIN, false),
  },
  staging: {},
  production: {},
}[win.BUILD_MODE || 'development']
